import { ActionTypes, EnrichedCustomer, SetEnrichedCustomerAction } from "~/types/enrich-customer";

export const setEnrichedCustomer = (
  enrichedCustomer: EnrichedCustomer | Record<string, never>
): SetEnrichedCustomerAction => {
  return { type: ActionTypes.SET_ENRICHED_CUSTOMER, enrichedCustomer };
};
